import { searchActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    searchStr: '',
    loading: false,
    searching: false
};

export const reducer = createReducer(initialState, {
    [searchActions.quickSearchTyped]: (state, action) => {
        state.searching = true;
        state.searchStr = action.payload;
    },
    [searchActions.quickSearchRequest]: (state, action) => {
        state.loading = true;
    },
    [searchActions.quickSearchSuccess]: (state, action) => {
        state.loading = false;
    },
    [searchActions.quickSearchClear]: (state, action) => {
        state.loading = false;
        state.searching = false;
        state.searchStr = '';
    }
})


